import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { H1, Loading, ContentHolder } from "commons";
import { isInsideGoReactNativeApp } from "commons/src/helpers/ReactNativeAppHelpers";

import { AnalysisConfig } from "./AnalysisConfig";
import { AnalysisViewContent } from "./AnalysisViewContent";

export function AnalysisView({ account, filteredAnalysis, history, rangeId, selectedAccounts }) {
    const dataFetchingComplete =
        !!filteredAnalysis &&
        !!selectedAccounts &&
        (!!selectedAccounts[account] || account === "Combined");

    const showHeader = !isInsideGoReactNativeApp();

    return (
        <ContentHolder>
            {showHeader ? <H1>Analysis</H1> : null}
            <AnalysisConfig accountNum={account} rangeId={rangeId} history={history} />

            {account !== "default" && (
                <AnalysisLoading displayWhen={dataFetchingComplete} size={30}>
                    {dataFetchingComplete && (
                        <AnalysisViewContent
                            key={`${account}-${rangeId}`}
                            rangeId={rangeId}
                            filteredAnalysis={filteredAnalysis}
                            account={account}
                            selectedAccounts={selectedAccounts}
                        />
                    )}
                </AnalysisLoading>
            )}
        </ContentHolder>
    );
}

export const AnalysisLoading = styled(Loading)`
    display: flex;
    justify-content: center;
    margin-top: 5%;
`;

AnalysisView.propTypes = {
    account: PropTypes.string,
    filteredAnalysis: PropTypes.object,
    history: PropTypes.object,
    rangeId: PropTypes.string,
    selectedAccounts: PropTypes.object
};
